/**
 * Stable key for request-level vs HCP license list comments (IDs can overlap across tables).
 */
export function getCommentDedupeKey(comment) {
  if (!comment || comment.id == null) return null;
  if (comment.hcp_licenses_list_id != null) {
    return `hcp:${comment.id}`;
  }
  if (comment.profile_section_key != null) {
    return `hcpProf:${comment.id}`;
  }
  return `req:${comment.id}`;
}
